import { useCallback, useState } from 'react';
import { Checkbox } from '../ui/checkbox';

interface Props {
  toggleCheckbox?: boolean;
  onClick?: () => void;
}

const CustomCheckbox = (props: Props) => {
  const { onClick, toggleCheckbox: toggleCheckboxProps = false } = props;
  const [toggleCheckbox, setToggleCheckbox] = useState(toggleCheckboxProps);

  const onToggle = useCallback(() => {
    setToggleCheckbox((prevState) => !prevState);
    if (!!onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <Checkbox
      checked={toggleCheckbox}
      onCheckedChange={onToggle}
      className="data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground"
    />
  );
};

export default CustomCheckbox;
